const DescriptiveSelectionConfig = [
    { span: 12, height: "27px", classes: "marginTop-24" },
    { span: 12, height: "77px", classes: "marginTop-16" },
    { span: 12, height: "77px", classes: "marginTop-16" },
    { span: 12, height: "1px", classes: "marginTop-16" },
    { span: 12, height: "40px", classes: "marginTop-16" },
]
export default DescriptiveSelectionConfig
